export const seeHelpWidget = 'user can see help widget';
